import { Button, Checkbox, InputNumber, Slider, Typography } from "antd";

export interface SetupValues {
  rotation: number;
  brickWidthMm: number | null;
  brickHeightMm: number | null;
}

interface Props {
  values: SetupValues;
  detected: boolean;
  changed: boolean;
  onChange(values: SetupValues): void;
  onCommit(): void;
  onRedetect(): void;
  guides: boolean;
  onGuides(guides: boolean): void;
}

const SetupPanel: React.FC<Props> = ({
  values,
  detected,
  changed,
  guides,
  onChange,
  onCommit,
  onRedetect,
  onGuides,
}) => {
  const complete = values.brickWidthMm != null && values.brickHeightMm != null;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
      <Typography.Text strong>Full brick in this photo</Typography.Text>
      <div style={{ display: "flex", gap: 8 }}>
        <InputNumber
          style={{ flex: 1 }}
          suffix="mm"
          placeholder="Width"
          min={10}
          max={1000}
          value={values.brickWidthMm}
          onChange={(v) => onChange({ ...values, brickWidthMm: v })}
          onBlur={onCommit}
          onPressEnter={onCommit}
        />
        <InputNumber
          style={{ flex: 1 }}
          suffix="mm"
          placeholder="Height"
          min={10}
          max={1000}
          value={values.brickHeightMm}
          onChange={(v) => onChange({ ...values, brickHeightMm: v })}
          onBlur={onCommit}
          onPressEnter={onCommit}
        />
      </div>
      <Typography.Text strong>Straighten</Typography.Text>
      <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
        <Slider
          style={{ flex: 1 }}
          min={-5}
          max={5}
          step={0.1}
          value={values.rotation}
          onChange={(rotation) => onChange({ ...values, rotation })}
        />
        <InputNumber
          style={{ width: 80 }}
          min={-5}
          max={5}
          step={0.1}
          suffix="°"
          value={values.rotation}
          onChange={(v) => onChange({ ...values, rotation: v ?? 0 })}
        />
      </div>
      <Checkbox checked={guides} onChange={(e) => onGuides(e.target.checked)}>
        Show horizontal guides
      </Checkbox>
      {!detected && !complete && (
        <Typography.Text type="secondary">Enter the size of a full brick to detect bricks.</Typography.Text>
      )}
      {detected && (
        <Button onClick={onRedetect} disabled={!complete} type={changed ? "primary" : "default"}>
          Re-detect bricks
        </Button>
      )}
    </div>
  );
};

export default SetupPanel;
